import { render, staticRenderFns } from "./AgendaHeader.vue?vue&type=template&id=10d4a063&"
import script from "./AgendaHeader.vue?vue&type=script&lang=js&"
export * from "./AgendaHeader.vue?vue&type=script&lang=js&"
import style0 from "./AgendaHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports